'use client';

import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Theme } from '@mui/material';
import Link from '@mui/material/Link';
import { SxProps } from '@mui/system/styleFunctionSx';
import { BlockContainer } from '@/components/Blocks/BlockContainer';
import { BlockTitle } from '@/components/Blocks/components/BlockTitle';
import { ResponsiveSlider } from '@/components/Blocks/components/ResponsiveSlider';
import { BlogPostCard } from '@/components/Cards/BlogPostCard';
import { useSiteLinkPrefix } from '@/hooks/useSiteLinkPrefix';
import { CmsElementBlogPost } from '@/services/cms/blocks/CmsElementBlogPosts';

export interface BlogPostBlockProps extends CmsElementBlogPost {
    sx?: SxProps<Theme>;
}

export const BlogPostBlock = ({ sx, ...props }: BlogPostBlockProps) => {
    const addSiteLinkPrefix = useSiteLinkPrefix();
    return (
        <BlockContainer sx={sx} {...props}>
            <BlockTitle {...props} />
            <ResponsiveSlider>{props.posts?.map((blogPost) => <BlogPostCard key={`blog-post-${blogPost.id}`} blogPost={blogPost} />)}</ResponsiveSlider>
            <Link variant="subtitle1" href={addSiteLinkPrefix(props.blogLink)} sx={{ display: 'flex', alignItems: 'center', mt: 3 }}>
                View all articles <ChevronRightIcon color="primary" />
            </Link>
        </BlockContainer>
    );
};
